// @flow

import React, { PureComponent } from 'react';
import ym, { YMInitializer } from 'react-yandex-metrika';
import { withRouter } from 'react-router-dom';
import { toNumber, isEmpty } from 'lodash';
import type { ContextRouter } from 'react-router-dom';

type Props = ContextRouter;

const METRIKA_ID = toNumber(process.env.REACT_APP_YANDEX_METRIKA_ID);

class Metrika extends PureComponent<Props> {
  prevProps = {};

  componentWillReceiveProps() {
    this.prevProps = this.props;
  }

  componentDidMount() {
    this.hit();
  }

  componentDidUpdate() {
    this.hit();
  }

  hit() {
    const referer = !isEmpty(this.prevProps)
      ? this.prevProps.location.pathname
      : '';

    const options = {
      referer,
    };

    ym('hit', this.props.location, options);
  }

  render() {
    return <YMInitializer accounts={[METRIKA_ID]} />;
  }
}

export default withRouter(Metrika);



// WEBPACK FOOTER //
// ./src/components/Metrika/index.js